import { Autocomplete, TextField } from '@mui/material';
import { Profile } from '../../../../services/profileService/model/profile/Profile';

interface ProfileSearchProps {
    profiles: Profile[];
    selectedProfile: Profile | null;
    onSearch: (searchTerm: string) => void;
    onChange: (profile: Profile | null) => void;
}

export function ProfileSearch({ profiles, selectedProfile, onSearch, onChange }: ProfileSearchProps) {
    return (
        <Autocomplete
            options={profiles}
            getOptionLabel={(profile) => profile.fullName}
            value={selectedProfile}
            onInputChange={(e, value) => onSearch(value)}
            onChange={(e, value) => onChange(value)}
            renderInput={(params) => <TextField {...params} label="Search Profile" variant="outlined" />}
            sx={{ marginBottom: 2 }}
        />
    );
}
